import { render, staticRenderFns } from "./SaveAvatarModal.vue?vue&type=template&id=e45fc724&scoped=true&"
import script from "./SaveAvatarModal.vue?vue&type=script&lang=js&"
export * from "./SaveAvatarModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveAvatarModal.vue?vue&type=style&index=0&id=e45fc724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45fc724",
  null
  
)

export default component.exports